import { object, string, array, date, boolean, InferType } from 'yup';

// Special structure for Referral documents copied into EBP
export const ReferralGenericDocumentsSchema = object().shape({
  // all documents are successfully converted from Word to PDF in Referrals,
  // and AI can parse them
  readyForAnalyze: boolean(),
  referrals: array()
    .of(
      object().shape({
        name: string().required('Document name is required'),
        path: string().required(),
        uploadedToHealee: object()
          .shape({
            at: date().required(),
            by: string().nullable(),
          })
          .optional()
          .default(undefined),
      }),
    )
    .max(20, 'Maximum can be uploaded 20 documents'),
  consent: object()
    .shape({
      name: string().required('Consent form is required'),
      path: string().required(),
    })
    .required(),
});

export type ReferralGenericDocuments = InferType<
  typeof ReferralGenericDocumentsSchema
>;
